// extracted by mini-css-extract-plugin
export var title = "MainTitle-module--title--3Kel-";